import React from 'react';
import RightNav from './RightNav';

class Burger extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
  }

  render() {
    return (
      <div>
        <div className={this.state.open ? "navigation-mobile__burger active" : "navigation-mobile__burger"} open={this.state.open} role='presentation' onKeyDown={() => this.setState({open: !this.state.open})} onClick={() => this.setState({open: !this.state.open})}>
          <div />
          <div />
          <div />
        </div>
        <RightNav open={this.state.open} data={this.props}/>
      </div>
    )
  }


}
export default Burger